import { recordsApi } from "shared/api/recordsApi";

export const myEventsRecordsRequest = (payload, options = {}) => {
  return recordsApi.myEventsRecords({ ...payload, signal: options.signal });
};
